
import { defineComponent, toRefs } from 'vue'
import BaseMsg from '../basemsg/index.vue'
import { twoFloat } from "@/utils/number";

interface logistdetail{
    twoNumber: (val: number) => number;
    columns1: any;
    columns2: any;
    columns3: any;
    columns4: any;
    columns5: any;
    columns6: any;
    txtchange: (txt:string, type:string) => void;
    changeTxt: (t: string, type: string) => void;
}

export default defineComponent({
    name: 'LogistDetail',
    components: {BaseMsg},
    props: {
        tableData: {
            type: Object,
            default: ()=>{return {}}
        },
        countrylist: {
            type: Array,
            default: ()=>{return []}
        },
    },
    setup(props):logistdetail{
        const {countrylist} = toRefs(props)
        //显示转换
        const txtchange = (txt:string, type:string = '') => {
            const txtEtyObj = {0: '未审核',1: '审核中',2:'审核通过',3:'审核不通过'}
            const pickobj = {
                1:'周一',
                2:'周二',
                3:'周三',
                4:'周四',
                5:'周五',
                6:'周六',
                7:'周日',
            }
            const def = {'def': txt}
            try {
                let t:string = ''
                switch(type) {
                    case 'auditStatus':
                        t = txtEtyObj[txt]
                        return t
                    case 'pick':
                        let tt = txt!=''&&txt.split(',').map((i:string)=>{return `${pickobj[i]}`})
                        return tt&&tt.join(',') || ''
                    case '':
                        return def['def']
                }
            } catch (error) {

            }
        }

        const columns1 = [
            // {title: '客户编号',dataIndex: 'userCode'},
            // {title: '订单来源',dataIndex: 'orderSource'},
            {title: '交易单号',dataIndex: 'transactionNo'},
            {title: '苍鸾单号',dataIndex: 'gwtNo'},
            {title: '目的国',dataIndex: 'destination'},
            {title: '产品类别',dataIndex: 'productType'},
            {title: '商品属性',dataIndex: 'hasBattery'},
            {title: '目的国派送单号',dataIndex: 'deliveryNo'},
            {title: '下单重量(g)',dataIndex: 'orderWeight'},
            {title: '实际重量(g)',dataIndex: 'actualWeight'},
            {title: '长*宽*高(cm)',dataIndex: 'width'},
            {title: '实际长*宽*高(cm)',dataIndex: 'actualWidth'},
            {title: '体积重量(g)',dataIndex: 'volumeWeight'},
            {title: '申报价值总额',dataIndex: 'amount'},
            {title: '申报币种',dataIndex: 'amountCurrency'},
            {title: 'VAT/IOSS',dataIndex: 'vatIoss'},
        ]

        const columns2 = [
            {title: '序号',dataIndex: 'index'},
            {title: 'SKU编码',dataIndex: 'skuCode'},
            {title: '中文申报名称',dataIndex: 'declareNameCn'},
            {title: '商品属性',dataIndex: 'hasBattery'},
            {title: '英文申报名称',dataIndex: 'declareNameEn'},
            {title: '单个货品申报重量(g)',dataIndex: 'declareWeight'},
            {title: '申报产品数量',dataIndex: 'declareNumber'},
            {title: '申报产品链接',dataIndex: 'declareUrl'},
            {title: '申报价值(单个)',dataIndex: 'declareValue'},
            {title: '申报币种',dataIndex: 'currency'},
            {title: '海关编码',dataIndex: 'hsCode'},
            {title: '申报的产品材质',dataIndex: 'material'},
            {title: '申报的产品用途',dataIndex: 'purpose'},
        ]

        const columns3 = [
            {title: '收件人姓名',dataIndex: 'userName'},
            {title: '收件人电话',dataIndex: 'mobilePhone'},
            {title: '收件人国家中文名称',dataIndex: 'countryCn'},
            {title: '收件人国家英文名称',dataIndex: 'countryEn'},
            {title: '收件人国家二字码',dataIndex: 'countryCode2'},
            {title: '收件人邮编',dataIndex: 'zipCode'},
            {title: '收件人省/州',dataIndex: 'province'},
            {title: '收件人城市',dataIndex: 'city'},
            {title: '收件人地址1',dataIndex: 'detailedAddress1'},
            {title: '收件人地址2',dataIndex: 'detailedAddress2'},
            {title: '收件人电子邮箱',dataIndex: 'email'},
        ]

        const columns4 = [
            {title: '联系人姓名',dataIndex: 'userName'},
            {title: '联系人电话',dataIndex: 'mobilePhone'},
            {title: '发件人国家中文名称',dataIndex: 'countryCn'},
            {title: '发件人国家英文名称',dataIndex: 'countryEn'},
            {title: '发件人国家二字码',dataIndex: 'countryCode2'},
            {title: '发件人邮编',dataIndex: 'zipCode'},
            {title: '发件人省/州',dataIndex: 'province'},
            {title: '发件人城市',dataIndex: 'city'},
            {title: '发件人地址1',dataIndex: 'detailedAddress1'},
            // {title: '发件人地址2',dataIndex: 'detailedAddress2'},
            // {title: '发件人电子邮箱',dataIndex: 'email'},
        ]

        const columns5 = [
            {title: '联系人姓名',dataIndex: 'contacts'},
            {title: '联系人电话',dataIndex: 'mobilePhone'},
            {title: '省',dataIndex: 'province'},
            {title: '市',dataIndex: 'city'},
            {title: '区',dataIndex: 'region'},
            {title: '详细地址',dataIndex: 'detailedAddress'},
            {title: '邮编',dataIndex: 'zipCode'},
            {title: '揽收周期',dataIndex: 'pickupCycle'},
            {title: '地址审核状态',dataIndex: 'auditStatus'},
        ]

        const columns6 = [
            {title: '事件发生时间',dataIndex: 'eventTime'},
            {title: '国家二字码',dataIndex: 'countryCode2'},
            {title: '订单状态',dataIndex: 'eventCodeCn'},
        ]

        const changeTxt = (t: string, type: string) => {
            const hObj = {0: '普货', 1: '带电'}
            const proTypeObj={
                1:'标准'
            }
            const def = {def: t}
            switch(type){
                case 'hasBattery':
                    return hObj[t] || def['def']
                case 'countryCn':
                    return (countrylist.value as any[]).filter((item:any) => item.countryCode2==t)[0].name || def['def']
                case 'countryEn':
                    return (countrylist.value as any[]).filter((item:any) => item.countryCode2==t)[0].nameEn || def['def']
                case 'productType':
                    return proTypeObj[t] || '-'
                default:
                    return def['def']
            }
        }

        const twoNumber = (val: any) => {
            return twoFloat(val);
        };


        return {
            columns1,
            columns2,
            columns3,
            columns4,
            columns5,
            columns6,
            txtchange,
            changeTxt,
            twoNumber
        }
    }
})
